import { FC } from 'react';
import Link from 'next/link';
import styles from './BtnReadOnline.module.scss';

interface IBtnReadOnline {
  alias: string;
  target?: string;
  name?: string;
  mobWide?: boolean;
}

const BtnReadOnline: FC<IBtnReadOnline> = ({ alias, target, name, mobWide = true }) => {
  return (
    <Link prefetch={false} className={mobWide ? `${styles.btn_orange} ${styles.btn_orange_mobWide}` : `${styles.btn_orange}`} href={alias} target={target ? target : '_self'}>
      {name ? name : 'Читать книгу онлайн'}
    </Link>
  );
};

export default BtnReadOnline;
